/**
 * Get the next rent due date from unit due day (1–31).
 * Clamps to last day of month (e.g. due 31 in Feb → 28).
 */
export function getNextRentDueDate(dueDay: number): Date {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const lastDayThisMonth = new Date(year, month + 1, 0).getDate();
  const dayThisMonth = Math.min(dueDay, lastDayThisMonth);
  let next = new Date(year, month, dayThisMonth);
  if (next <= now) {
    const lastDayNextMonth = new Date(year, month + 2, 0).getDate();
    next = new Date(year, month + 1, Math.min(dueDay, lastDayNextMonth));
  }
  return next;
}

export function formatNextDueDate(dueDay: number): string {
  return getNextRentDueDate(dueDay).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
